// extracted by mini-css-extract-plugin
export var accept = "cookieConsent-module--accept--80067";
export var consent = "cookieConsent-module--consent--cb95a";
export var consentActions = "cookieConsent-module--consentActions--e9d26";
export var consentLabel = "cookieConsent-module--consentLabel--108f9";
export var consentText = "cookieConsent-module--consentText--60619";
export var decline = "cookieConsent-module--decline--e4e3c";